import { IonRow, IonCol, IonGrid, IonCheckbox } from "@ionic/react";
import React, { useEffect, useState } from "react";
import {
  DestinationRadius,
  Dropdate,
  Destination,
  Anywhere,
} from "../../../utils/constants";
import { NewInput } from "../common/OriginInput";
import { RadiusRange } from "../RadiusRange/RadiusRange";

const DestinationLocation = (props: any) => {
  const [checked, setChecked] = useState<boolean>(true);

  const {
    destinationError,
    destination,
    destinationCountry,
    destinationPostalCode,
    destinationRadius,
    defaultValue,
    isDestination,
    useHandler,
    setErrorValue,
    updateLocalCurrentTime,
  } = props;
  const upDateLocalTime = (time: string) => {
    updateLocalCurrentTime(Dropdate, time);
  };
  useEffect(() => {
    setChecked(destination === Anywhere);
  }, [destination]);
  return (
    <IonGrid className="destination-location-grid">
      <IonRow className="destination-location-row">
        <IonCol className="destination-location-col">
          <div className="destination-input">
            <div className="textbox-destination">
              <NewInput
                Error={destinationError}
                locationValue={false}
                labelValue=""
                InputValue={destination}
                InputName={Destination}
                handleChange={props.handleChange}
                keyboardshowHandler={props.keyboardshowHandler}
                keyboardhideHandler={props.keyboardhideHandler}
                deFaultValue={defaultValue}
                isDestination={isDestination}
                useHandler={useHandler}
                setErrorValue={setErrorValue}
                getLocalTime={upDateLocalTime}
                onFocus={props.onFocus || (() => {})}
                country={destinationCountry}
                postalCode={destinationPostalCode}
                placeholder="Select City"
              />
            </div>
            {!props.isLane && (
              <div className={`checkbox-destination checkbox-solid ${checked ? "checked" : "not-checked"}`}>
                <IonCheckbox
                  checked={checked}
                  onClick={(e) => {
                    props.handleCheck(e);
                  }}
                />{" "}
                Anywhere
              </div>
            )}
          </div>
        </IonCol>
      </IonRow>
      <IonRow className="destination-location-row">
        <IonCol className="destination-location-col">
          <RadiusRange
            labelName="Destination Radius"
            rangeDisabled={props.rangeDisable}
            InputValue={destinationRadius}
            className="destinationRadius"
            name={DestinationRadius}
            handleChange={props.handleChange}
          />
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
export default DestinationLocation;
